var PageModel = (function (app, dialog) {

    var eventHandler = $({});
    var $deferred = new $.Deferred();
    var $success = new $.Deferred();
    var $always = new $.Deferred();

    var PurchasePixel = PurchasePixelModule();
    var PaymentInfoPixel = PaymentInfoPixelModule();

    var CheckoutModel = Backbone.Model.extend({
        eventHandler: eventHandler,

        initialize: function () {
            _.bindAll(this);
            this.pixel = new PurchasePixel();
            this.paymentInfoPixel = new PaymentInfoPixel();

            app.checkout.orderXhr.done(this.loaded).always(this._always);
            app.checkout.onUpdate(this.update);

            this.listenTo(app.models.payment, 'PaymentSuccess', this.success);
        },

        loaded: function () {
            $deferred.resolve(this);
        },

        _always: function () {
            $always.resolve(this);
        },

        update: function (data) {

            if (data.NotificationMessage) {
                dialog({
                    closeBtn: false,
                    message: data.NotificationMessage
                });
            }

            Pixel.events.trigger('basketUpdate', data);
        },

        success: function (details) {
            var data = _.extend({}, details, { currentAddress: app.models.delivery.current });
            eventHandler.trigger('Success', data);
            $success.resolve(data);

            this.paymentInfoPixel && this.paymentInfoPixel.trigger(details, app.models);

            this.pixel.confirmation(details, this);
        }
    });

    var checkoutModel = new CheckoutModel();

    return {
        always: function (cb) {
            $always.done(cb);
        },
        done: function (cb) {
            $deferred.done(cb);
        },
        success: function (cb) {
            $success.done(cb);
        }
    }

    $deferred.promise();
})(app, kos.dialog.popup, GlobalSettings, globalQueryParams, CheckoutSettings);

var basketPageModule = function (app) {
    var BasketView = Backbone.View.extend({
        el: '@basket',
        initialize: function () {
            _.bindAll(this);
            this.model.on('change:IsEmpty', this.toggle);
            this.toggle(this.model.get('IsEmpty'));
        },
        toggle: function (isEmpty) {
            this.$el.toggle(!isEmpty);
        }
    });

    new BasketView({ model: app.models.page });
};

var emptyPageModule = function (app) {
    var EmptyPageView = Backbone.View.extend({
        el: '@basketEmpty',
        initialize: function () {
            _.bindAll(this);
            this.model.on('change:IsEmpty', this.toggle);
            this.toggle(this.model.get('IsEmpty'));
        },
        toggle: function (display) {
            if (display && window.BestSellers) {
                BestSellers.init(this.$('@bestSellers'), true);
            }
            this.$el.toggle(display || false);
        }
    });
    new EmptyPageView({ model: app.models.page });
};

var confirmationModule = function (_pageModel, _globalSettings) {

    var ConfirmationView = Backbone.View.extend({
        el: '@confirmation',
        basketRole: '@basket',
        newPaymentMethodContainerRole: '@newPaymentMethodContainer',
        newPaymentMethodOverlayRole: '@newPaymentMethodOverlay',
        hiddenClass: 'hidden-block',

        initialize: function () {
            _.bindAll(this);

            this._initElements();

            _pageModel.success(this._onSuccess);
        },

        _initElements: function () {
            this.$basket = $(this.basketRole);
            this.$newPaymentMethodContainer = $(this.newPaymentMethodContainerRole);
            this.newPaymentMethodOverlay = $(this.newPaymentMethodOverlayRole);
            this.$invoiceField = this.$el.find('@checkoutConfirmationInvoiceNo');
            this.$siteNameField = this.$el.find('@checkoutConfirmationSiteFullName');
            this.$arriveWithinField = this.$el.find('@checkoutConfirmationWillArriveWithin');
            this.$estimateDeliveryTextField = this.$el.find('@checkoutConfirmationDeliveryText');
            this.$emailAddress = this.$el.find('@emailAddress');
            this.$phoneNumber = this.$el.find('@phoneNumber');
            this.$firstname = this.$el.find('@firstname');
            this.$lastname = this.$el.find('@lastname');
            this.$street = this.$el.find('@street');
            this.$city = this.$el.find('@city');
            this.$region = this.$el.find('@region ');
            this.$postcode = this.$el.find('@postcode');
            this.$country = this.$el.find('@country');
            this.$postcheckoutAddressText = this.$('@postcheckoutAddressText');
            this.$plannedTransactions = this.$('@confirmationPlannedTransactions');
            this.$giftVoucher = this.$('@giftVoucher');
            this.$bestSellers = this.$('@bestSellers');
            this.$('#lblSiteFullName').html(_globalSettings.SiteFullName);
        },

        _onSuccess: function (data) {
            var _City = '';
            if (data.Value.OrderInfoResult.DeliveryAddress.City !== null)
                _City += data.Value.OrderInfoResult.DeliveryAddress.City;

            if (data.Value.OrderInfoResult.DeliveryAddress.Suburb !== null)
                _City += ' ' + data.Value.OrderInfoResult.DeliveryAddress.Suburb;

            _City = _City.trim();


            var parsed = {
                invoiceNo: data.Value.invoiceNo || data.Value.InvoiceNo,
                siteName: _globalSettings.SiteFullName,
                estimatedDeliveryText: data.Value.OrderInfoResult.EstimatedDeliveryText,
                plannedTransactions: data.Value.PlannedTransactions,
                paymentMethodType: data.paymentMethodType,
                voucher: data.Value.voucher,
                addressString: data.Value.AddressString || '',
                orderId: data.Value.OrderInfoResult.InvoiceNo,
                addressAdditionalData: data.Value.AddressAdditionalData,
                email: data.Value.OrderInfoResult.Email,
                phone: data.Value.OrderInfoResult.DeliveryAddress.Phone,
                firstname: data.Value.OrderInfoResult.CustomerFirstName,
                lastname: data.Value.OrderInfoResult.CustomerLastName,
                street: data.Value.OrderInfoResult.DeliveryAddress.AddressLines,
                city: _City,
                region: data.Value.OrderInfoResult.DeliveryAddress.State,
                postcode: data.Value.OrderInfoResult.DeliveryAddress.Postcode,
                country: data.Value.OrderInfoResult.CustomerCountryName,
            };

            if (window.BestSellers) {
                BestSellers.init(this.$bestSellers, true);
            }

            //if address is not pickup point
            if (!parsed.addressAdditionalData || parsed.addressAdditionalData.length === 0) {
                var link = '/my-account/orders/' + parsed.invoiceNo + '/change-address?invoice_no=' + parsed.orderId;

                window.app &&
                    app.event &&
                    app.event.stripeFailed &&
                    app.event.confirmationInfo(parsed.addressString);

                this.$postcheckoutAddressText.html($.tmpl('bt-checkout-confirm-address',
                    {
                        Address: parsed.addressString.split(','),
                        ChangeAddressLink: link
                    }));
            }

            if (parsed.voucher) {
                this.$giftVoucher.html($.tmpl('bt-checkout-gift-voucher',
                    {
                        Discount: window.toMoney(parsed.voucher.Amount, _globalSettings.CurrencySign).replace(/\.00$/, ''),
                        MinSpend: window.toMoney(parsed.voucher.MinSpend, _globalSettings.CurrencySign).replace(/\.00$/, ''),
                        ExpiryDate: parsed.voucher.ExpiryDate,
                        MyVouchersLink: CheckoutSettings.getBasketSettings().MyVouchersLink
                    }));
                this.$giftVoucher.removeClass('hidden-block');
            }

            if (parsed.paymentMethodType === CheckoutSettings.PaymentSystemType.mypay) {
                parsed.plannedTransactions &&

                    this.$plannedTransactions.append(new MyPayTransactionsView({ collection: parsed.plannedTransactions, type: 'large' }).$el.show());
            } else {
                this.$('@plannedTransactionsWrapper').hide();
            }

            this.$invoiceField.text(parsed.invoiceNo);
            this.$siteNameField.text(parsed.siteName);
            this.$emailAddress.text(parsed.email);
            this.$phoneNumber.text(parsed.phone);
            this.$firstname.text(parsed.firstname);
            this.$lastname.text(parsed.lastname);
            this.$street.text(parsed.street);
            this.$city.text(parsed.city);
            this.$region.text(parsed.region);
            this.$postcode.text(parsed.postcode);
            this.$country.text(parsed.country);

            if (parsed.estimatedDeliveryText) {
                this.$arriveWithinField.addClass(this.hiddenClass);
                this.$estimateDeliveryTextField.removeClass(this.hiddenClass).css('display', 'block').html(parsed.estimatedDeliveryText);
            }

            this.render();

            !function (_this, app, CheckoutSettings) {
                var basketSettings = CheckoutSettings.getBasketSettings();

                if (!(basketSettings && basketSettings.RoktEnabled)) {
                    return;
                }

                var _address = _.extend({}, data.currentAddress.toJSON(), data.Value.CurrentAddress) || {};

                var _name = _address.Name && _address.Name.split(' ') || '',
                    lastName = _name && _name.pop(),
                    firstName = _name && _name.join(' '),
                    postcode = _address.Postcode || '',
                    email = data.Value.un,
                    id = basketSettings.RoktID;

                _this._callROKT(id, firstName, lastName, email, postcode);
            }(this, app, CheckoutSettings);
        },

        render: function () {
            this.$el.removeClass(this.hiddenClass).css('display', 'block');
            this.$basket.addClass(this.hiddenClass).css('display', 'none');
            this.$newPaymentMethodContainer.addClass(this.hiddenClass).css('display', 'none');
            this.newPaymentMethodOverlay.addClass(this.hiddenClass).css('display', 'none');
            return this;
        },

        _callROKT: function (id, firstName, lastName, email, postcode) {
            if (!id) {
                return;
            }

            var _bhid = id + '-b';

            // TBD: Create wrapper in the template and style by not inline styles.
            this.$el.append($('<div>').append($('<div>').attr('id', _bhid).css({
                'border': '1px solid #ebebeb',
                'width': '700px',
                'margin': '40px auto',
                'border-radius': '6px'
            })).css('text-align', 'center'));

            !function () {
                var rokt = window._ROKT = window._ROKT || [];

                // Recommended
                rokt.push(['email', email]);

                // Consumer
                rokt.push(['firstname', firstName]);
                rokt.push(['lastname', lastName]);

                // Address
                rokt.push(['zipcode', postcode]);
                rokt.push(['country', _globalSettings.Iso]);


                var js = document.createElement('SCRIPT');
                js.type = 'text/JavaScript';
                js.async = true;
                js.src = location.protocol + '//apps.rokt.com/?id=' + id + '&bhid=' + _bhid + '&v=' + Math.floor(Math.random() * 999).toString();
                var p = document.getElementsByTagName('script')[0];
                p.parentNode.insertBefore(js, p);
            }();
        }
    });

    new ConfirmationView();
};

var MyPayErrorHandler = (function (model) {
    var MyPayErrorHandler = function (model) {
        this.model = model;
        this.model.on('payError', _.bind(this._onError, this));
        this._dialog = _.clone(api.o).dialog;
    };

    _.extend(MyPayErrorHandler.prototype, {
        _onError: function (errorMessage) {
            this.model.isRejectedByOutOfRange() && this._dialog(this.renderOutOfRange());
            this.model.isRejectedByExceededDebtLimit() && this._dialog(this.renderExceededDebtLimit());
            this.model.isRejectedByInvalidPaymentMethodFromResponse() && this._dialog(this.renderInvalidPaymentMethod());
            this.model.isRejectedByUntrusted() && this._dialog(GetPageTemplate('_checkoutMyPayPayUntrusted'));
        },
        renderOutOfRange: function () {
            var templateName = app.models.paymentConditions.get('MinAmountThreshold') ? '_checkoutMyPayPayOutOfRange' : '_checkoutMyPayPayOutUpTo';
            return GetPageTemplate(templateName).format(
                $('<div>').html($.tmpl('bt-checkout-mypay-logo')).html(),
                this.toMoney(app.models.paymentConditions.get('MinAmountThreshold')),
                this.toMoney(app.models.paymentConditions.get('MaxAmountThreshold'))
            );
        },

        renderExceededDebtLimit: function () {
            return GetPageTemplate('_checkoutMyPayPayExceedLimit').format(
                $('<div>').html($.tmpl('bt-checkout-mypay-logo')).html()
            );
        },

        renderInvalidPaymentMethod: function () {
            return GetPageTemplate('_checkoutMyPayPayInvalidPaymentMethod').format(
                $('<div>').html($.tmpl('bt-checkout-mypay-logo')).html()
            );
        },

        toMoney: function (value) {
            return window.convertMoney.toMoney(value, GlobalSettings.CurrencySign).replace(/\.00/, '');
        }
    });

    return new MyPayErrorHandler(model);
});

var paymentModule = function (payment, summaryModel, GlobalSettings, CheckoutSettings, MyPayErrorHandler, _BaseView) {
    if (!payment) return;

    var myPayErrorHandler = MyPayErrorHandler(app.models.ourpay);

    var BraintreePaymentFormView = BaseView.extend({

        el: '@newPaymentContainer',

        initialize: function () {
            _.bindAll(this);

            this._render();
            this._onLoading();

            this._update(app.models.currentMethod);
            this.listenTo(app.models.currentMethod, 'change:CurrentMethod', this._update);
       },

        _render: function () {
            this.$el.prepend($.tmpl('bt-add-payment-method'));
            this._setupBraintree();
            this._setupStripe();
        },

        _update: function (model) {
            var display = !model.hasCurrentMethod() && !model.get('UseDirectPayment');
            this.$el.toggle(display);
        },

        _onLoading: function () { },

        _setupStripe: function () {
            var settings = _.pick(CheckoutSettings.getBasketSettings(), 'IsStripeEnabled', 'StripePublicKey', 'PaymentRequestButtonEnabled');

            if (settings.IsStripeEnabled()) {
                app.stripe = new StripeHelper(settings.StripePublicKey);
                app.stripe.init();

                /* initialize stripe payment request button */
                if (settings.PaymentRequestButtonEnabled) {

                    var validation = _.bind(function () {
                        return this.beforePayButtonClickAsync().then(payment.validateCheckout);
                    }, this);

                    app.stripe.ready(function (stripe) {
                        app.stripePaymentRequest = new StripePaymentRequest();

                        app.stripePaymentRequest.init(stripe, validation, payment.payStripePaymentRequest, app.models.summary.get('TotalWithSelect'));
                        app.models.summary.on('change', function (model) {
                            app.stripePaymentRequest.update(model.get('TotalWithSelect'));
                        });
                    });
                }
            }
        },

        _setupBraintree: function () {
            var settings = _.pick(CheckoutSettings.getBasketSettings(), 'BTEnvironment', 'KountEnabled', 'KountMerchantID', 'UsePayPal', 'PayPalEnvironment', 'IsStripeEnabled');
            app.Braintree.init({
                btEnvironment: settings.BTEnvironment.toLowerCase(),
                kountEnabled: settings.KountEnabled,
                kountMerchantID: settings.KountMerchantID,
                usePayPal: settings.UsePayPal,
                payPalEnvironment: settings.PayPalEnvironment,
                currency: GlobalSettings.CurrencySign,
                useHostedfields: !settings.IsStripeEnabled()
            }).done(_.bind(function () { }, this));
        }
    });

    var MyPayView = _BaseView.extend({
        hiddenClass: 'hidden-block',

        events: {
            'click': '_onClickButton'
        },

        initialize: function (opt) {
            _.bindAll(this, 'render');

            this.listenTo(this.model, 'update', this.render);

            this.myPayErrorHandler = opt.myPayErrorHandler;

            this.render();
        },

        render: function () {

            var display = true;
            var ourpayDisabled = app.models.ourpay.ourpayMode() === 0 || app.models.ourpay.ourpayMode() === 2;

            if ((!this.model.isEnabled() || app.models.currentMethod.get('UseDirectPayment')) && ourpayDisabled) {
                display = false;
            }

            if (this.model.isRejectedByInvalidPaymentMethod() || this.model.isRejected()) {
                display = false;
            }

            this.$el.toggleClass(this.hiddenClass, !display);

            return this;
        },

        _onClickButton: function (e) {
            var _this = this;
            var settings = CheckoutSettings.getBasketSettings();
            var method = app.models.payment.getCurrentPaymentMethod();

            e.preventDefault();

            if (app.models.ourpay.ourpayMode() === 3) {
                return this.beforePayButtonClickAsync().then(payment.validateCheckout).then(_.bind(function () {
                    if (!method || method.IsNew) {
                        window.app && app.event && app.event.ourpay();
                    } else {
                        window.app && app.event && app.event.currentOurpay(method.PaymentType);
                    }

                    var el = kos.dialog.popup({
                        title: '',
                        message: $.tmpl('ourpay-klarna-popup').html(),
                        hideOnClick: false,
                        hideOnOverlayClick: true,
                        closeBtn: true
                    });

                    el.$('@klarna-ourpay-button-other').on('click', el.destroy);

                    el.$('@klarna-ourpay-button').on('click', function (evt) {
                        evt.preventDefault();

                        if (settings.KlarnaEnabled) {
                            var _valdateFunction = _.bind(function () {
                                return _this.beforePayButtonClickAsync().then(_this.model.validateCheckout);
                            }, _this);

                            var _successFunction = _.bind(function (result) {
                                app.models.payment.trigger('PaymentSuccess',
                                    _.extend(result, {
                                        paymentMethodType: 'Klarna'
                                    }));
                            }, _this);

                            var klarnaHelper = KlarnaHelper(_valdateFunction, _successFunction,
                                function () {
                                    var items = app.models.itemsList.map(function (m) {
                                        var i = m.toJSON();
                                        return {
                                            name: i.Item,
                                            //quantity: i.Qty,
                                            //unit_price: i.Price,
                                            //total_amount: i.Subtotal,
                                            product_url: i.ProductLink,
                                            image_url: i.ImgUrl
                                        };
                                    });
                                    return items;
                                }
                            );

                            var klarna = klarnaHelper.buttonPopup();
                            app.checkout.onUpdate(klarna.update);
                        }

                        el.destroy();
                    });
                }, this));
            } else {
                return this.beforePayButtonClickAsync().then(_.bind(function () {
                    if (!method || method.IsNew) {
                        window.app && app.event && app.event.ourpay();
                    } else {
                        window.app && app.event && app.event.currentOurpay(method.PaymentType);
                    }

                    this.model.set('AgreedWithTerms', true, { silent: true });
                    this.model.pay(settings.IsStripeEnabled());
                }, this));
            }
        }
    });

    var PayPalFreeDeliveryController = {
        View: {
            allPaymentMethods: 0,
            currentPaymentMethod: 1
        },

        _labelOne: $('@checkoutPayPalFreeDeliveryWrapper'),
        _labelTwo: $('@checkoutPayPalFreeDeliveryAdditionalText'),
        _labelOneForCurrentMethod: $('@checkoutPayPalFreeDeliveryWrapperCurrentMethod'),
        _labelOneForCurrentMethodBottom: $('@checkoutPayPalFreeDeliveryWrapperCurrentMethodBottom'),
        _disposed: false,
        _isEnabled: window.app.settingsUtils.getSiteDataGeneralSetting('FreeDeliveryPromo'),
        _initPromise: new $.Deferred(),

        dispose: function () {
            if (this._disposed) return;
            this._labelOne.remove();
            this._labelTwo.remove();
            this._disposed = true;
        },

        hide: function () {
            this._labelOne.html('');
            this._labelTwo.html('');
            this._labelOneForCurrentMethod.html('');
            this._labelOneForCurrentMethodBottom.html('');
        },

        enable: function () {
            this._initPromise.resolve();
        },

        _show: function (cfg) {
            if (this._disposed) return;

            if (!this._isEnabled) {
                this.dispose();
                return;
            }

            if (this._showForAllPaymentMethodsBinded) {
                app.models.summary.off('change', this._showForAllPaymentMethodsBinded);
            }

            if (this._showForCurrentPaymentMethodBinded) {
                app.models.summary.off('change', this._showForCurrentPaymentMethodBinded);
            }

            if (cfg === PayPalFreeDeliveryController.View.allPaymentMethods) {
                this._showForAllPaymentMethods(app.models.summary);
                app.models.summary.on('change', this._showForAllPaymentMethodsBinded || (this._showForAllPaymentMethodsBinded = this._showForAllPaymentMethods.bind(this)));
            } else if (cfg === PayPalFreeDeliveryController.View.currentPaymentMethod) {
                this._showForCurrentPaymentMethod(app.models.summary);
                app.models.summary.on('change', this._showForCurrentPaymentMethodBinded || (this._showForCurrentPaymentMethodBinded = this._showForCurrentPaymentMethod.bind(this)));
            }
        },

        show: function (cfg) {
            var _this = this;
            this._initPromise.done(function () { _this._show(cfg); });
            return true;
        },

        getTotalWithFreeDelivery: function (summary) {
            if (this._isEnabled) {
                if (!!summary.get('Select')) {
                    return summary.get('TotalWithSelect') - summary.get('Delivery');
                }
                return summary.get('Total') - summary.get('Delivery');
            }
            return summary.get('Total');
        },

        _showForAllPaymentMethods: function (summary) {
            var total = this.getTotalWithFreeDelivery(summary);

            this._labelOne.html($.tmpl('bt-checkout-paypal-free-delivery-label-top',
                {
                    Total: window.toMoney(total, GlobalSettings.CurrencySign)
                }));

            this._labelTwo.html($.tmpl('bt-checkout-paypal-free-delivery-label-bottom'));
            this._labelOneForCurrentMethod.html('');
            this._labelOneForCurrentMethodBottom.html('');
        },

        _showForCurrentPaymentMethod: function (summary) {
            var total = this.getTotalWithFreeDelivery(summary);
            this._labelOneForCurrentMethod.html($.tmpl('bt-checkout-paypal-free-delivery-label-top',
                {
                    Total: window.toMoney(total, GlobalSettings.CurrencySign)
                }));

            this._labelOne.html('');
            this._labelTwo.html('');
            this._labelOneForCurrentMethodBottom.html($.tmpl('bt-checkout-paypal-free-delivery-label-bottom'));
        }
    };

    var AfterpayButtonView = _BaseView.extend({
        el: '@afterpayContainer',
        events: {
            'click @btnAfterpay': '_pay',
            'click @afterpayLearnMore': '_displayInfo'
        },
        initialize: function () {
            _.bindAll(this, '_render', '_pay', '_lock', '_unlock');
            this.listenTo(this.model, 'change', this._render);
            this.isLocked = false;
            this._render();
        },
        _render: function () {
            var data = this.model.toJSON();
            this.$el.html($.tmpl('bt-checkout-button-afterpay', this.model.toJSON()));

            if (data.IsAvailable) {
                this.$el.removeAttr("style");
            } else {
                this.$el.css({ display: 'none' });
            }
        },
        _lock: function () {
            this.isLocked = true;
        },
        _unlock: function () {
            this.isLocked = false;
        },
        _pay: function () {
            return this.beforePayButtonClickAsync().then(_.bind(function () {
                if (!this.isLocked) {
                    this._lock();
                    window.app && app.event && app.event.afterpay();
                    app.models.payment.payAfterpay()
                        .always(this._unlock);
                }
            }, this));
        },
        _displayInfo: function () {
            var el = kos.dialog.popup({
                title: '',
                message: '<a href="https://www.afterpay.com/terms" target="_blank"><img width="500" height="500" src="Res/Default/Img/Checkout/afterpay-lightbox.png" /></a>',
                hideOnClick: false,
                hideOnOverlayClick: true,
                closeBtn: true
            });
            el.$('a').on('click', function (e) {
                e.stopPropagation();
            });
        }
    });

    var OpenpayButtonView = _BaseView.extend({
        el: '@openpayContainer',
        events: {
            'click @btnOpenpay': '_pay'
        },
        initialize: function () {
            _.bindAll(this, '_render', '_pay', '_lock', '_unlock');
            this.listenTo(this.model, 'change', this._render);
            this.isLocked = false;
            this._render();
        },
        _render: function () {
            var data = this.model.toJSON();
            this.$el.html($.tmpl('bt-checkout-button-openpay', this.model.toJSON()));

            if (data.IsAvailable) {
                this.$el.removeAttr("style");
            } else {
                this.$el.css({ display: 'none' });
            }
        },
        _lock: function () {
            this.isLocked = true;
        },
        _unlock: function () {
            this.isLocked = false;
        },
        _pay: function () {
            return this.beforePayButtonClickAsync().then(_.bind(function () {
                if (!this.isLocked) {
                    this._lock();
                    window.app && app.event && app.event.openpay();
                    app.models.payment.payOpenpay()
                        .always(this._unlock);
                }
            }, this));
        }
    });


    var PaymentButtonsView = _BaseView.extend({
        hiddenClass: 'hidden-block',
        LOADING_CLASS: 'cursor-progress',

        el: '#braintreeForm',

        events: {
            'click @masterpassCheckout': 'payMasterPass',
            'click @ipayCheckout': 'payIPay',
            'click @termsCheckbox': 'onTermsCheckboxClick'
        },

        initialize: function (opt) {
            _.bindAll(this);

            this._logger =
                InsightLogger &&
                InsightLogger.payButtonsClickLogger &&
                InsightLogger.payButtonsClickLogger(app.models.summary, false);

            this.paymentOptionToButtonsMapping = {};
            this.$terms = this.$el.find('@terms');
            this.$payNewBTButton = $('@btCheckoutButton');
            this.$masterpassContainer = this.$el.find('@masterpassContainer');
            this.$masterpass = this.$el.find('@masterpassCheckout');
            this.$visaCheckout = this.$el.find('@visaCheckout');
            this.$ipay = this.$el.find('@ipayCheckout');
            this.$paypal = this.$el.find('@checkoutPayPal');
            this.$paypalcredit = this.$el.find('@checkoutPayPalCredit');
            this.$afterpay = this.$el.find('@afterpayContainer');
            this.$openpay = this.$el.find('@openpayContainer');
            this.$lPayContainer = this.$el.find('@LPayContainer');
            this.$klarna = this.$el.find('#klarna');
            this.$ourpayText = this.$el.find('@ourpayText');

            this.$checkout = $('@checkoutButton');

            this._initTermsCheckbox();
            this._initPayNewBTButton();
            this._initPayPal();
            this._initPayMasterpass();
            this._initPayIPay();
            this._initVisaCheckout();
            this._initKlarna();
            this._initAfterpay();
            this._initOpenpay();
            this._initHumm();
            this._initZip();
            this._initLPay();
            this._initOurpayText();

            this._update(app.models.currentMethod);
            this._toggle(app.models.currentMethod);
            this.listenTo(app.models.currentMethod, 'change:CurrentMethod', this._update);
            this.listenTo(app.models.currentMethod, 'change', this._toggle);
            this.listenTo(app.models.ourpay, 'update', this._toggle);

            this._onLoading();

            app.Braintree.onSetupDone(_.bind(this._onBTSetupDone, this));

            new MyPayView({
                model: app.models.ourpay,
                el: this.$('@myPayButton'),
                myPayErrorHandler: opt.myPayErrorHandler
            });
        },

        _initOurpayText: function () {
            var showExtraMessage = false;

            if (app.models.ourpay.ourpayMode() === 2) {
                showExtraMessage = true;
            }

            this.$ourpayText.toggleClass(this.hiddenClass, !showExtraMessage);
        },

        _initKlarna: function () {
            var settings = CheckoutSettings.getBasketSettings();
            if (settings.KlarnaEnabled) {

                var _valdateFunction = _.bind(function() {
                    return this.beforePayButtonClickAsync().then(this.model.validateCheckout);
                }, this);

                var _successFunction = _.bind(function(result) {
                    app.models.payment.trigger('PaymentSuccess',
                        _.extend(result, {
                            paymentMethodType: 'Klarna'
                        }));
                }, this);

                var klarnaHelper = KlarnaHelper(_valdateFunction, _successFunction,
                    function () {

                        var items = app.models.itemsList.map(function (m) {
                            var i = m.toJSON();
                            return {
                                name: i.Item,
                                //quantity: i.Qty,
                                //unit_price: i.Price,
                                //total_amount: i.Subtotal,
                                product_url: i.ProductLink,
                                image_url: i.ImgUrl
                            };
                        });

                        return items;
                    }
                );
                var klarna = klarnaHelper.replaceWith(this.$klarna, $('#klarna-tc-text'));

                this.paymentOptionToButtonsMapping[CheckoutSettings.PaymentOption.Klarna] = this.$el.find('#klarna');

                app.checkout.onUpdate(klarna.update);
            } else {
                this.$klarna.remove();
                $('#klarna-tc-text').remove();
            }
        },

        _initAfterpay: function () {
            if (CheckoutSettings.getBasketSettings().AfterpayEnabled) {
                new AfterpayButtonView({ model: app.models.AfterpayModel });
                this.paymentOptionToButtonsMapping[CheckoutSettings.PaymentOption.Afterpay] = this.$afterpay;
            } else {
                this.$afterpay.remove();
            }
        },

        _initOpenpay: function () {
            if (CheckoutSettings.getBasketSettings().OpenpayEnabled) {
                new OpenpayButtonView({ model: app.models.OpenpayModel });
                this.paymentOptionToButtonsMapping[CheckoutSettings.PaymentOption.Openpay] = this.$openpay;
            } else {
                this.$openpay.remove();
            }
        },

        _initHumm: function () {
            var settings = CheckoutSettings.getBasketSettings();
            if (settings.HummEnabled && window.Humm) {
                var humm = new Humm(settings.HummEndpoint);

                var _pay = _.bind(function () {
                    return this.beforePayButtonClickAsync().then(app.models.payment.payHumm);
                }, this);

                this.$hummEl = humm.init('humm', app.models.summary, _pay, true);
                if (this.$hummEl !== null) {
                    this.paymentOptionToButtonsMapping[CheckoutSettings.PaymentOption.Humm] = this.$hummEl;
                }
            }
        },

        _initZip: function () {
            var settings = CheckoutSettings.getBasketSettings();

            var _valdateFunction = _.bind(function () {
                return this.beforePayButtonClickAsync().then(this.model.validateCheckout);
            }, this);

            if (settings.ZipEnabled) {
                this.$zipPayAuButton = zip.appendAUButton($('#zip'), _valdateFunction, app.models.payment.success, true);
                if (this.$zipPayAuButton !== null) {
                    this.paymentOptionToButtonsMapping[CheckoutSettings.PaymentOption.ZipPayAU] = this.$zipPayAuButton;
                }

                this.$zipPayNzButton = zip.appendNZButton($('#zip'), _valdateFunction, app.models.payment.success, app.models.summary.get('Total'), true);
                if (this.$zipPayNzButton !== null) {
                    this.paymentOptionToButtonsMapping[CheckoutSettings.PaymentOption.ZipPayNZ] = this.$zipPayNzButton;
                    app.models.summary.on('change', function (model) {
                        zip.updateAmount(model.get('Total'));
                    });
                }
            } else {
                $('#zip').remove();
            }
        },

        _initLPay: function () {
            var settings = CheckoutSettings.getBasketSettings();

            if (settings.LPayEnabled) {
                var _valdateFunction = _.bind(function () {
                    return this.beforePayButtonClickAsync().then(this.model.validateCheckout);
                }, this);

                this.$lPayContainer = lpay.init(this.$lPayContainer, _valdateFunction, app.models.payment.success, true);
                lpay.updateAmount(app.models.summary.get('Total'));
                this.paymentOptionToButtonsMapping[CheckoutSettings.PaymentOption.LPay] = this.$lPayContainer;
                app.models.summary.on('change', function (model) {
                    lpay.updateAmount(model.get('Total'));
                });
            } else {
                this.$lPayContainer.remove();
            }
        },

        _initPayMasterpass: function () {
            if (CheckoutSettings.getBasketSettings().UseMasterPass) {
                this.$masterpass.replaceWith($.tmpl('bt-checkout-button-masterpass', {
                    id: 'btnMasterpass',
                    role: 'masterpassCheckout',
                    testClass: 'test-masterpass-button'
                }));
                this.$masterpass = this.$el.find('@masterpassCheckout');
                this.paymentOptionToButtonsMapping[CheckoutSettings.PaymentOption.MasterPassPayment] = this.$masterpassContainer;
            } else {
                this.$masterpassContainer.remove();
            }
        },

        _initVisaCheckout: function () {
            var visaSettings = CheckoutSettings.getBasketSettings().Visa;
            if (visaSettings.Enabled) {
                if (visaSettings.ProviderType === 2) {
                    this.paymentOptionToButtonsMapping[CheckoutSettings.PaymentOption.VisaCheckoutBrainTree] = this.$visaCheckout;
                } else {
                    this.paymentOptionToButtonsMapping[CheckoutSettings.PaymentOption.VisaCheckoutCyberSource] = this.$visaCheckout;
                }

                visa_checkout_button.appendButtonTo(this.$visaCheckout, {
                    id: 'checkoutVisa',
                    role: 'checkoutVisa',
                    testClass: 'test-visa-button'
                }, this._prePaymentVisa, visaSettings.APIUrl, 205);

                visa_checkout_instance.init(visaSettings.APIUrl, _.bind(function () {
                    // NOTE: enum, can be found somewhere in the confluence
                    if (visaSettings.ProviderType === 2) {
                        app.Braintree.onSetupDone(_.bind(function () {
                            this._initVisaCheckout_Braintree();
                            app.checkout.onUpdate(this._setVisaCheckout_Braintree_Amount);

                        }, this));
                    } else {
                        this._initVisaCheckout_Native(visaSettings);
                    }
                }, this));
            } else {
                this.$visaCheckout.remove();
            }
        },

        _prePaymentVisa: function () {
            window.app && app.event && app.event.visacheckout();
            return this.beforePayButtonClickAsync().then(this.model.prePaymentVisa);
            //return this.model.prePaymentVisa();
        },

        _initVisaCheckout_Braintree: function () {
            app.Braintree.visaCheckout.initVisaLiteBox(app.models.summary.get('Total'), this.model.payNewBtVisa);
        },

        _setVisaCheckout_Braintree_Amount: function () {
            app.Braintree.visaCheckout.set_amount(app.models.summary.get('Total'));
        },

        _initVisaCheckout_Native: function (visaSettings) {
            var visaCheckout = new VisaCheckout({
                apikey: visaSettings.APIKey,
                enabled: visaSettings.Enabled,
                visaApiDomain: visaSettings.APIUrl,
                success: _.bind(this.model.payNewVisaCheckout, this.model),
                error: function (data) { console.log(data); },
                cancel: function (data) { console.log(data); },
                totals: summaryModel.toJSON(),
                currencyCode: GlobalSettings.Currency,
                prePayment: this.model.prePaymentVisa
            });
            summaryModel.on('change', function (model) {
                visaCheckout.updateTotals(model.toJSON());
            });
            visaCheckout.initVisa();
            this.visaCheckout = visaCheckout;
        },

        _initPayIPay: function () {
            if (CheckoutSettings.getBasketSettings().UseIPay && IsAuthorized()) {
                this.$ipay.replaceWith($.tmpl('bt-checkout-button-ipay'));
                this.$ipay = this.$el.find('@ipayCheckout');
                this.paymentOptionToButtonsMapping[CheckoutSettings.PaymentOption.IPay88Payments] = this.$ipay;
            } else {
                this.$ipay.remove();
            }
        },

        _initPayPal: function () {
            var settings = CheckoutSettings.getBasketSettings();
            if (settings.UsePayPal || settings.UsePayPalCredit) {
                this.paymentOptionToButtonsMapping[CheckoutSettings.PaymentOption.BrainTreePayPal] = this.$paypal;
                this.paymentOptionToButtonsMapping[CheckoutSettings.PaymentOption.BrainTreePayPalCredit] = this.$paypalcredit;
                app.Braintree.paypal.ready(_.bind(function (btpaypal) {
                    if (btpaypal.isEnabled()) {
                        settings.UsePayPal && btpaypal.createButton('#paypal-button', 'checkout', this._paypalValidate, this.model._payWithBraintreePaypal, 50, 'paypal');
                        settings.UsePayPalCredit && btpaypal.createButton('#paypal-button-credit', 'credit', this._paypalCreditValidate, this.model._payWithBraintreePaypalCredit, 50);

                        // enable paypal free delivery if paypal is enabled
                        PayPalFreeDeliveryController.dispose();
                    } else {
                        $('#paypal-button').remove();
                        $('#paypal-button-credit').remove();

                        // disable paypal free delivery if paypal is disabled
                        PayPalFreeDeliveryController.dispose();
                    }
                }, this));
            } else {
                // disable paypal free delivery if paypal is disabled
                PayPalFreeDeliveryController.dispose();
            }
            !settings.UsePayPal && this.$paypal.remove();
            !settings.UsePayPalCredit && this.$paypalcredit.remove();
        },

        _paypalValidate: function (resolve, reject) {

            if (this._logger) {
                this._logger(InsightLogger.actions.payWithNewPayPal);
            }
            window.app && app.event && app.event.paypal();

            return this._ppValidate(resolve, reject);
        },

        _paypalCreditValidate: function (resolve, reject) {
            if (this._logger) {
                this._logger(InsightLogger.actions.payWithNewPayPal);
            }
            window.app && app.event && app.event.paypalCredit();

            return this._ppValidate(resolve, reject);
        },

        _ppValidate: function (resolve, reject) {
            var _validator = app.models.payment.getValidator();

            return this.beforePayButtonClickAsync()
                .then(_validator.process)
                .then(this.addressVerification)
                .done(function () {
                    resolve({
                        amount: PayPalFreeDeliveryController.getTotalWithFreeDelivery(app.models.summary),
                        currency: GlobalSettings.Currency,
                        currencySing: GlobalSettings.CurrencySign,
                        displayName: GlobalSettings.SiteFullName
                    });
                })
                .fail(reject);
        },

        _initPayNewBTButton: function () {
            this.$payNewBTButton.replaceWith($.tmpl('bt-checkout-button-pay', {
                id: 'braintree',
                role: 'btCheckoutButton',
                testClass: 'test-pay-button'
            }));
            this.$payNewBTButton = $('@btCheckoutButton');
            this.paymentOptionToButtonsMapping[CheckoutSettings.PaymentOption.BrainTree] = this.$payNewBTButton;

            this.$payNewBTButton.on('click', this.payNewBT);
        },

        _initCurrentPayButton: function (method) {
            var templateData = {
                id: 'checkoutButton',
                role: 'checkoutButton',
                testClass: 'test-pay-button'
            };

            if (method.IsVisaCkoutBraintree || method.IsVisaCkoutCyberSource) {
                this.$checkout.replaceWith($.tmpl('bt-checkout-button-pay', templateData));
            } else {
                var templateName;
                if (method.IsMasterPass) {
                    templateName = 'bt-checkout-button-masterpass';
                } else if (method.IsPayPal) {
                    templateName = 'bt-checkout-button-paypal';
                } else if (method.IsDirect) {
                    templateName = 'bt-checkout-button-pay';
                } else {
                    templateName = 'bt-checkout-button-pay';
                }

                this.$checkout.replaceWith($.tmpl(templateName, templateData));
            }

            this.$checkout = $('@checkoutButton');
            this.$checkout.on('click', this.pay);

        },

        _initTermsCheckbox: function () {
            var termsSettings = CheckoutSettings.termsAndConditions,
                isTermsCheckboxSelected = termsSettings.isCheckboxSelected(),
                isTermsEnabled = termsSettings.isEnabled();

            if (isTermsEnabled) {
                this.$terms = $.tmpl('bt-checkout-terms-checkbox', {
                    id: 'termsCheckbox',
                    role: 'terms',
                    testClassCheckbox: 'test-check-terms',
                    testClassLabel: 'test-label-terms',
                    text: GetPageTemplate("_CheckoutTermsAndConditions"),
                    checked: isTermsCheckboxSelected
                }).prependTo(this.$el);
            }

            this.model.getValidator().setIsAgreedWithTerms(!isTermsEnabled || isTermsCheckboxSelected);
        },

        pay: function (e) {
            e.preventDefault();


            var paymentMethod = this.model.getCurrentPaymentMethod();
            if (!paymentMethod.IsMasterPass && !paymentMethod.IsDirect && paymentMethod.Token) {
                if (paymentMethod.OrderPaymentType === CheckoutSettings.OrderPaymentType.BrainTreePayPal) {
                    this._logger && this._logger(InsightLogger.actions.payWithPayPal);
                }
                if (paymentMethod.OrderPaymentType === CheckoutSettings.OrderPaymentType.BrainTree) {
                    this._logger && this._logger(InsightLogger.actions.payWithCreditCard);
                }
            }
            
            var xhr = this.model.payWithCurrentMethod();
            if (xhr && xhr.always) {
                this._buttonInProgress(true, this.$checkout);
                xhr.always(_.bind(this._buttonInProgress, this, false, this.$checkout));
            }
        },

        payNewBT: function (e) {
            e.preventDefault();

            this.beforePayButtonClickAsync().then(_.bind(function () {
                this._logger(InsightLogger.actions.payWithNewCreditCard);

                var settings = CheckoutSettings.getBasketSettings();
                var xhr;

                this._buttonInProgress(true, this.$payNewBTButton);
                
                if (settings.IsStripeEnabled()) {
                    window.app && app.event && app.event.stripeCreditCard();
                    xhr = this.model.payNewStripe();
                } else {
                    window.app && app.event && app.event.creditCard();
                    xhr = this.model.payNewBT();
                }
                xhr.always(_.bind(this._buttonInProgress, this, false, this.$payNewBTButton));
            }, this));


        },

        _buttonInProgress: function (state, button) {
            button.toggleClass('processing-animation', state);
        },

        payMasterPass: function (e) {
            e.preventDefault();
            return this.beforePayButtonClickAsync().then(_.bind(function () {
                window.app && app.event && app.event.masterpass();
                this.model.payMasterPass();
            }, this));
        },

        payIPay: function (e) {
            e.preventDefault();
            var animationClass = 'processing-animation';
            var button = this.$ipay
            button.addClass(animationClass);
            return this.beforePayButtonClickAsync().then(_.bind(function () {
                window.app && app.event && app.event.iPay();
                this.model.payIPay().fail(function () {
                    button.removeClass(animationClass);
                });
            }, this));
        },

        onTermsCheckboxClick: function (e) {
            this.model.getValidator().setIsAgreedWithTerms(e.currentTarget.checked);
        },

        _toggleButtons: function (display, buttons) {
            var hiddenClass = this.hiddenClass;
            _.each(buttons, function (button) {
                button && button.toggleClass(hiddenClass, !display);
            });
        },

        _showAll: function (current) {
            this._toggleAvailableButtons([this.$payNewBTButton], [this.$checkout], this.paymentOptionToButtonsMapping);

            // NOTE: show paypal free delivery label
            PayPalFreeDeliveryController.show(PayPalFreeDeliveryController.View.allPaymentMethods);
        },

        _showButton: function (current) {
            var po = CheckoutSettings.PaymentOption;
            var buttonsToHide = [this.$payNewBTButton, this.$paypal, this.$paypalcredit, this.$masterpassContainer, this.$visaCheckout, this.$ipay, this.$hummEl, this.$zipPayAuButton, this.$zipPayNzButton, this.$afterpay, this.$openpay, this.$lPayContainer, this.$klarna, this.$checkout];
            var installmentButtons = _.pick(this.paymentOptionToButtonsMapping, po.Humm, po.Afterpay, po.Openpay,po.ZipPayAU, po.ZipPayNZ, po.LPay, po.Klarna);

            this._toggleButtons(false, buttonsToHide);

            this._initCurrentPayButton(current);

            this._toggleAvailableButtons([this.$checkout], [], installmentButtons);

            // NOTE: show paypal free delivery label
            current.IsPayPal && PayPalFreeDeliveryController.show(PayPalFreeDeliveryController.View.currentPaymentMethod) || PayPalFreeDeliveryController.hide();


        },

        _toggleAvailableButtons: function (buttonsToShow, buttonsToHide, paymentOptionToButtonsMapping) {
            buttonsToShow = buttonsToShow || [];
            buttonsToHide = buttonsToHide || [];
            paymentOptionToButtonsMapping = paymentOptionToButtonsMapping || [];

            for (var paymentOption in paymentOptionToButtonsMapping) {
                if (!!app.models.availablePaymentOptions && app.models.availablePaymentOptions.isOptionApplicable(paymentOption))
                    buttonsToShow.push(paymentOptionToButtonsMapping[paymentOption]);
                else
                    buttonsToHide.push(paymentOptionToButtonsMapping[paymentOption]);
            }

            this._toggleButtons(true, buttonsToShow);
            this._toggleButtons(false, buttonsToHide);
        },

        _update: function (model) {
            var current = model.getCurrentMethod();
            if (current) {
                current.IsDirect = model.get('UseDirectPayment');
                if (model.hasCurrentMethod() || current.IsDirect) {
                    this._showButton(current);
                } else {
                    this._showAll(current);
                }
            }
        },

        _toggle: function () {
            var isDirect = app.models.currentMethod.get('UseDirectPayment');
            if (!app.models.currentMethod.hasCurrentMethod() && !isDirect) {
                this.$checkout.addClass('hidden-block');
            } else {
                var hidePaymentOption = !app.models.currentMethod.applicableByPaymentOptions();

                var hide = !isDirect && (app.models.ourpay.displayAlone() || hidePaymentOption);

                this.$checkout.toggleClass('hidden-block', hide);
            }
        },

        _onBTSetupDone: function () {
            this.$el.children().removeClass(this.LOADING_CLASS);
        },

        _onLoading: function () {
            this.$el.children().addClass(this.LOADING_CLASS);
        }
    });

    var PaymentMethodView = Backbone.View.extend({

        className: 'bt-payment-method-row',

        events: {
            'click': 'select'
        },

        initialize: function () {
            _.bindAll(this, 'render', 'select');

            this.listenTo(this.model, 'change:Selected', this._render);
            this.listenTo(this.model, 'remove', this.remove);

            this._render();
        },

        _render: function () {
            var method = this.model.toJSON();
            var isVisaCheckout = (method.PaymentType === CheckoutSettings.OrderPaymentType.VisaCheckoutBrainTree ||
                method.PaymentType === CheckoutSettings.OrderPaymentType.VisaCheckoutCyberSource);
            method.PaymentTypeText = isVisaCheckout ? 'Click to Pay' : method.PaymentType;
            method.IconClass = isVisaCheckout ? 'VisaCheckout' : method.PaymentType;

            this.$el.html($.tmpl('bt-payment-method', method));
            this.$el.toggleClass('bt-payment-method-selected', !!this.model.get('Selected'));
        },

        select: function () {
            this.model.setSelected();
        }
    });

    var PaymentMethodsView = Backbone.View.extend({
        el: '@paymentsList',

        initialize: function (opts) {
            _.bindAll(this);

            this.$el.addClass('bt-payments-list-loading');

            var el = this.$el;
            var spinner = new Spinner(spinnerConfig);
            var timeout = setTimeout(function () { spinner.spin(el[0]); }, CheckoutSettings.SpinnerTimeout);

            this.listenTo(this.collection, 'add', this._renderItem);

            this._render();

            this.toggleShowAll(false);

            this._update(app.models.currentMethod);
            this.listenTo(app.models.currentMethod, 'change:CurrentMethod', this._update);

            app.checkout.paymentXhr.done(function () {
                clearTimeout(timeout);
                spinner.stop();
                el.removeClass('bt-payments-list-loading');
            });
        },

        toggleShowAll: function (isShowAll) {
            this.isShowAll = isShowAll;
            this.$el.toggleClass('show-only-selected', !isShowAll);
        },

        _toggle: function (display) {
            this.$el.toggle(display);
        },

        _render: function () {
            this.collection.each(this._renderItem);
        },

        _renderItem: function (model) {
            var item = new PaymentMethodView({ model: model });
            this.$el.append(item.$el);
        },

        _update: function (model) {
            var hasMethod = model.hasCurrentMethod();
            this._toggle(hasMethod && this._applicable(model));
            this.toggleShowAll(false);
        },
        _applicable: function (model) {
            var type = model.get('CurrentMethod').OrderPaymentType;
            return type === CheckoutSettings.OrderPaymentType.BrainTree ||
                type === CheckoutSettings.OrderPaymentType.Stripe ||
                type === CheckoutSettings.OrderPaymentType.BrainTreePayPal ||
                type === CheckoutSettings.OrderPaymentType.MasterPassPayment ||
                type === CheckoutSettings.OrderPaymentType.VisaCheckoutBrainTree ||
                type === CheckoutSettings.OrderPaymentType.VisaCheckoutCyberSource;
        }
    });

    var PaymentView = Backbone.View.extend({

        el: '@paymentContainer',

        events: {
            'click @change': 'changePaymentMethod',
            'click @addPayment': 'showPaymentForm'
        },

        initialize: function (opt) {
            _.bindAll(this);

            this.$addPaymentItemBtn = this.$el.find('@addPayment');
            this.$changePaymentTokenBtn = this.$el.find('@change');
            this.$paymentTitle = this.$el.find('@paymentTitle');
            this.$paymentTitleText = this.$el.find('@paymentTitleText');

            this._paymentMethodForm = new BraintreePaymentFormView({ model: this.model });
            this._paymentMethods = new PaymentMethodsView({ collection: app.models.paymentMethods });
            this._paymentButtons = new PaymentButtonsView({ model: this.model, myPayErrorHandler: opt.myPayErrorHandler, collection: app.models.itemsList, summary: app.models.summary });

            this._update(app.models.currentMethod);
            this.listenTo(app.models.currentMethod, 'change:CurrentMethod', this._update);

            this.$el.show();
        },

        showPaymentForm: function (e) {
            e && e.preventDefault();
            app.models.currentMethod.setNew();
            //this.$paymentTitle.addClass('hidden-block');
        },

        changePaymentMethod: function (e) {
            e && e.preventDefault();

            app.models.ourpay.setShowAllButtons(true);

            app.models.paymentMethods.selectMethod();

            this._paymentMethods.toggleShowAll(app.models.currentMethod.getMethodsCount() > 1);
            this._toggleActions(true, false);
            //this.$paymentTitle.removeClass('hidden-block');
            this._showPayByTitle();
       },

        _showPaymentMethod: function () {
            var showChange;
            var showAdd;

            if (app.models.currentMethod.get('UseDirectPayment')) {
                showChange = false;
                showAdd = false;
            } else {
                var isOurpayByDefault = app.models.ourpay.displayAlone();
                showChange = isOurpayByDefault || !this._paymentMethods.isShowAll && app.models.currentMethod.getMethodsCount() > 1;
                showAdd = !showChange;
            }

            this._toggleActions(showAdd, showChange);
            //this.$paymentTitle.removeClass('hidden-block');
            this._showPayByTitle();
       },

        _update: function (model) {
            if (model.hasCurrentMethod()) {
                this._showPaymentMethod();
            } else {
                this._toggleActions(false, app.models.currentMethod.getMethodsCount() > 0 && !app.models.currentMethod.get('UseDirectPayment'));
                //this.$paymentTitle.removeClass('hidden-block');
                this._showCreditOrDebitCardTitle();
           }
        },

        _showPayByTitle: function () {
            this.$paymentTitleText.text('Pay by');
            this.$paymentTitle.removeClass('hidden-block');
        },

        _showCreditOrDebitCardTitle: function () {
            this.$paymentTitleText.text('Credit or debit card');
            this.$paymentTitle.removeClass('hidden-block');
        },

        _toggleActions: function (showAdd, showChange) {
            this.$addPaymentItemBtn.toggle(showAdd);
            this.$changePaymentTokenBtn.toggle(showChange);
        }
    });

    new PaymentView({ model: payment, myPayErrorHandler: myPayErrorHandler });
};

$(function () {
    $('@ccNotificationPopup').click(function () {
        kos.dialog.popup({ title: GetPageTemplate('_StoringCCDetailsNotification') });
    });
});

$(function () {
    var spinner = new Spinner(spinnerConfig);
    var timeout = setTimeout(function () { spinner.spin($('.base-content')[0]); }, CheckoutSettings.SpinnerTimeout);

    PageModel.always(function () {
        clearTimeout(timeout);
        spinner.stop();
    });

    confirmationModule(PageModel, GlobalSettings);
});

PageModel.done(function (model) {
    $(function () {

        var customerEmailView = CustomerEmailView();
        app.getCustomerData = customerEmailView.getCustomerData;
        var ViewCheckoutPixel = ViewCheckoutPixelModule();
        var ShippingInfoPixel = ShippingInfoPixelModule();

        paymentModule(app.models.payment, app.models.summary, GlobalSettings, CheckoutSettings, MyPayErrorHandler, BaseView);
        basketPageModule(app);
        emptyPageModule(app);
        itemsModule(app.models.itemsList, app.models.shipmentList, EstimateShippingPostcode, new ViewCheckoutPixel());
        summaryModule(app, EstimateShippingPostcode, GlobalSettings);

        var deliveryEventHandler = $({});
        var deliveryForms = {
            current: 1,
            add: 2,
            list: 3,
            chooser: 4,
            gift: 5
        };

        var FieldView = FieldViewModule(app);

        var EstimateShipmentView = EstimateShipmentViewModule(app, deliveryForms, deliveryEventHandler);

        deliveryOptionsModule(app, GlobalSettings, kos.dialog, BaseView);

        deliveryModule(app, EstimateShipmentView, EstimateShippingPostcode, GlobalSettings, deliveryEventHandler, deliveryForms, BaseView, FieldView, new ShippingInfoPixel());

        billingDeliveryModule(app, BaseView, FieldView, NewAddressForm);

        giftDeliveryModule(app, EstimateShippingPostcode, deliveryForms, BaseView, FieldView, NewAddressForm);

        AuthorizationViewModule(app, EstimateShipmentView, GlobalSettings, deliveryEventHandler, BaseView);

        deliveryEventHandler.trigger('switchFormMode');

    });
});